import { createStructureStatementHandler } from '../../createStructureStatementHandler';
import { getPreviewName } from '../../utils/nameFormat';
export const sortPreviewFieldsStmtInstruction = `
#### Sort fields in detail
- Syntax: \`sort preview fields in <preview_name>: <field_name>, <field_name>, ... ;\`
- Example: \`sort preview fields in ${getPreviewName('Product')}: name, description, category;\`
`;
export const stmtSortPreviewFields = ({ previewName, fieldNames }) => {
    return `sort preview fields in ${previewName}: ${fieldNames.join(', ')};`;
};
export const sortPreviewFieldsHandler = createStructureStatementHandler({
    type: 'sort preview fields',
    parse: line => {
        const match = /^sort preview fields in (?<previewName>\w+): (?<fieldNames>[\w\s.,]+)/.exec(line);
        return match?.groups
            ? {
                type: 'sort preview fields',
                previewName: match.groups.previewName,
                fieldNames: match.groups.fieldNames.split(',').map(it => it.trim()),
            }
            : null;
    },
    apply: (stmt, builder) => {
        builder.updateStructure(it => {
            return it.sortPreviewFields({
                previewName: stmt.previewName,
                fieldNames: stmt.fieldNames,
            });
        });
    },
});
//# sourceMappingURL=SortPreviewFieldsStmt.js.map